<span id="{{Id}}">{{displayDate | date: columnInfoDto.DateFormat : columnInfoDto.TimeZone : columnInfoDto.Locale}}</span>
